import React, { useContext } from "react";
import LanguageContext from "../../components/Language/LanguageContext";


const Product = () => {
  const { language, messages, changeLanguage } = useContext(LanguageContext);
  return (
    <>
      <div className="grid grid-nogutter surface-section text-800" id="product">
        <div
          className="col-12 md:col-12 text-center md:text-left flex align-items-center mb-5"
          style={{ marginTop: "50px" }}>
          <section style={{ width: "100%" }}>
            <div
              className="text-6xl font-bold text-center md:text-center smart"
              style={{
                color: "#013473",
                fontFamily: "Inter",
                marginBottom: "20px",
              }}>
              {messages.ProductJudul}
            </div>
            <p
              className="mt-0 mb-1 text-800 text-xl line-height-3 text-center isiProduct"
              style={{
                fontFamily: "Poppins",
                maxWidth: "1000px", // Batasi lebar maksimum konten
                margin: "auto  ", // Pusatkan konten di layar kecil
                paddingRight: "12px", // Padding besar untuk layar lebar
                paddingLeft: "12px", // Padding besar untuk layar lebar
              }}>
              {messages.isiProduct}
            </p>
          </section>
        </div>
        <div className="col-12 md:col-12 overflow-hidden text-center mt-2 p-3">
          <img
            src="/images/Product/product2.png"
            alt="hero-1"
            className="mx-auto"
            style={{
              width: "100%", // Set to 100% for responsiveness
              maxWidth: "1000px", // Set maximum width for larger screens
              height: "auto", // Maintain aspect ratio
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Product;
